import { render, staticRenderFns } from "./ConsentPopup.vue?vue&type=template&id=d4ba6cc4"
import script from "./ConsentPopup.vue?vue&type=script&lang=js"
export * from "./ConsentPopup.vue?vue&type=script&lang=js"
import style0 from "./ConsentPopup.vue?vue&type=style&index=0&id=d4ba6cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports